<script>
export default {
  name: 'RibbonItem',
  props: {
    contentLabel: { type: String, required: true },
    backgroundcolorRibbon: { type: String, default: 'gray' },
    colorRibbon: { type: String, default: 'dark' },
    type: { type: String, default: 'none' } // default: none
  }
}
</script>

<template functional>

  <div
    :class="{'ribbon__wrapper--vwa': props.type === 'vwa'}"
  >
    <div
      class="ribbon__content pl-1"
      :class="{'ribbon__content--vwa': props.type === 'vwa'}"
      :style="{
        backgroundColor: `var(--${props.backgroundcolorRibbon})`,
        color: `var(--${props.colorRibbon})`
      }"
      :aria-label="props.contentLabel"
    >
      {{ props.contentLabel }}
    </div>
  </div>
</template>

<style scoped lang="scss">
.ribbon {
  &__wrapper {
    position: absolute;
    top: 0;
    left: 0;
    height: 100px;      /* unverändert */
    width: 100px;       /* unverändert */
    overflow: hidden;   /* alles außerhalb wird „im Hintergrund“ abgeschnitten */
    z-index: 2;
    pointer-events: none;
  }

  &__wrapper--vwa {
    position: absolute;
    top: 100px;
    margin-left: 15px;
    height: 100px;      /* unverändert */
    width: 120px;       /* unverändert */
    overflow: hidden;   /* alles außerhalb wird „im Hintergrund“ abgeschnitten */
    z-index: 2;
    pointer-events: none;
  }

  /* Standard: diagonales Eck-Ribbon wie gehabt */
  &__content {
    position: absolute;
    top: 32px;
    left: -64px;
    height: 24px;
    width: 206px;
    transform: rotate(-45deg);
    background-color: var(--gray);
    color: var(--dark);
    text-align: center;
    padding-left: 10px !important;
    white-space: nowrap;
    z-index: 2;
  }

  /* VWA: horizontal, exakt mittig im 100x100-Clip, sonst alles „dahinter“ */
  &__content--vwa {
    top: 50%;
    left: 50%;

    /* Zentriert & gerade */
    transform: translate(-50%, -50%) rotate(0deg);

    /* Breiter Balken, damit er „hineinhängt“, Überschuss wird hidden */
    width: 260px;         /* ggf. 240–320px je nach Look */
    height: 28px;         /* leicht höher für bessere Lesbarkeit */
    line-height: 28px;
    padding-left: 0 !important;
    text-align: center;
    white-space: nowrap;
  }
}
</style>
